import Flex from "@/components/Flex"
import Typography from "@/components/Typography"
import Button from "@/components/Button"
import Box, { BoxProps } from "@/components/Box"
import React, { FC, ReactNode, useState } from "react"
import { ChevronDownNarrow, ChevronRightNarrow } from "@/components/Icon"

interface FilterMenuItemProps extends BoxProps {
  title: string
  content?: ReactNode
}

const FilterMenuItem: FC<FilterMenuItemProps> = ({
  title,
  content,
  ...props
}) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const IconComponent = isExpanded ? ChevronRightNarrow : ChevronDownNarrow
  const handleMenuClick = () => setIsExpanded(!isExpanded)
  return (
    <Box {...props}>
      <Button
        width="100%"
        variant="plain"
        onClick={handleMenuClick}
        height="44px"
      >
        <Flex alignItems="center" justifyContent="space-between">
          <Typography variant="h7" color="primaryBrightBlueLightBg" leadingTrim>
            {title}
          </Typography>
          <IconComponent fontSize="15px" />
        </Flex>
      </Button>
      {isExpanded && content}
    </Box>
  )
}

export default FilterMenuItem
